import { render, staticRenderFns } from "./fan-importer-page.vue?vue&type=template&id=808fc01e&"
import script from "./fan-importer-page.vue?vue&type=script&lang=js&"
export * from "./fan-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports